import { Pipe, PipeTransform } from '@angular/core';
import { ErrorMessages } from '../models';
import { TRANSFER_STATUS } from 'src/app/transfer/models/transfer.model';

@Pipe({
  name: 'translateTransferItem',
})
export class TranslateTransferItemPipe implements PipeTransform {
  public transform(status: string | number, shouldReturnAsHtml: boolean): string {
    let str = '';
    if (typeof status === 'string') {
      status = parseInt(status, 10);
    }
    if (ErrorMessages[status]) {
      return ErrorMessages[status];
    }
    switch (status) {
      case TRANSFER_STATUS.STATUS_WAITING:
        str = 'Waiting';
        break;
      case TRANSFER_STATUS.STATUS_WORKING:
        str = 'Working ...';
        break;
      case TRANSFER_STATUS.STATUS_ENC_UPLOAD:
        str = 'Encrypting file';
        break;
      case TRANSFER_STATUS.STATUS_UPLOAD:
        str = 'Uploading encrypted file';
        break;
      case TRANSFER_STATUS.STATUS_DECRYPT_DOWNLOAD:
        str = 'Decrypting';
        break;
      case TRANSFER_STATUS.STATUS_DOWNLOAD:
        str = 'Downloading encrypted file';
        break;
      case TRANSFER_STATUS.STATUS_PREPAREDOWNLOAD:
        str = 'Preparing file for download';
        break;

      case TRANSFER_STATUS.STATUS_ERR_SIZE:
        str = 'File is too large for this browser.';
        break;
      case TRANSFER_STATUS.STATUS_ERR_DISK_SPACE:
        str = 'Not enough space on disk to download this file.';
        break;
      case TRANSFER_STATUS.STATUS_ABORT:
        str = 'Stopped by user';
        break;
      case TRANSFER_STATUS.STATUS_ERROR:
        str = 'An error occurred.';
        break;
      case TRANSFER_STATUS.STATUS_ERR_OPEN:
        str = 'The browser cannot save/view this file';
        break;
      case TRANSFER_STATUS.STATUS_SUCCESS:
        str = 'Complete';
        break;
      case TRANSFER_STATUS.STATUS_UPLOAD_CANCELLED:
        str = 'Upload cancelled';
        break;
      case TRANSFER_STATUS.STATUS_DOWNLOAD_CANCELLED:
        str = 'Download cancelled';
        break;
      default:
        str = 'Unknown status.';
        break;
    }
    return str;
  }
}
